module.exports = __webpack_public_path__ + "img/lable_title_xh.2aa91540.svg";